import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['input', 'yes', 'no']

  connect() {
    this.sync()
  }

  setYes() {
    this.inputTarget.value = "true"
    this.sync()
  }

  setNo() {
    this.inputTarget.value = "false"
    this.sync()
  }

  sync() {
    const isYes = this.inputTarget.value === "true"
    this.yesTarget.dataset.on = isYes ? "true" : "false"
    this.noTarget.dataset.on = isYes ? "false" : "true"
  }
}
